import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import VoiceDirectory from "@/components/VoiceDirectory";
import { CHILD_VOICES, CHILD_VOICE_ORDER } from "@/config/childVoices";
import { ArrowRight } from "lucide-react";

export default function ChildVoices() {
  const jsonLd = {
    "@context": "https://schema.org", "@type": "CollectionPage",
    name: "Child & Kids Voice Over Artists",
    url: "https://www.voiceoverkids.agency/child-voices",
    description: "Directory of professional child and kids voice over artists in 25+ languages.",
  };

  return (
    <>
      <SEO title="Child & Kids Voice Over Artists" path="/child-voices"
        description="Browse professional child and kids voice over artists in 25+ languages. Listen to demos, filter by language, country, gender and voice age, then shortlist and cast."
        jsonLd={jsonLd} />

      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Voice database</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Child &amp; Kids Voice Over Artists</h1>
          <p className="mt-3 max-w-2xl text-zinc-300">
            The specialist international directory for genuine young voice talent. Filter by language,
            country, gender and voice age, listen to demos, then shortlist and cast the perfect child voice for your production.
          </p>
        </div>
      </section>

      <div className="container-x -mt-8 pb-4">
        <VoiceDirectory />
      </div>

      {/* Browse by language — crawlable internal links to every landing page */}
      <section className="bg-white border-t border-zinc-200 py-14">
        <div className="container-x">
          <span className="label-eyebrow text-brand-violet">Browse by language</span>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight md:text-3xl">Kids Voice Over Artists by Language</h2>
          <p className="mt-3 max-w-2xl text-zinc-600">Explore our specialist child and kids voice over talent by language and accent.</p>
          <div className="mt-8 grid gap-x-6 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-3">
            {CHILD_VOICE_ORDER.map((slug) => (
              <Link key={slug} to={`/child-voices/${slug}`} data-testid={`browse-lang-${slug}`}
                className="group inline-flex items-center gap-2 text-zinc-700 transition hover:text-brand-violet">
                <ArrowRight size={14} className="text-brand-violet opacity-60 transition group-hover:translate-x-0.5" />
                <span className="font-semibold">{CHILD_VOICES[slug].h1}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
